import { __assign } from 'tslib';
import React__default, { useState, useRef, useEffect } from 'react';
import { Button, Grow, Paper, ClickAwayListener, MenuList, MenuItem } from '@mui/material';
import clsx from 'clsx';
import DefaultIcon from '../../DefaultIcon/index.js';
import StyledButtonGroup, { buttonGroupClasses, StyledPopper } from './index.styled.js';

var KSplitButton = function (_a) {
    var value = _a.value, splitLabel = _a.splitLabel, splitValues = _a.splitValues, onSplitSelect = _a.onSplitSelect, onSplitOpen = _a.onSplitOpen, className = _a.className, _b = _a.testId, testId = _b === void 0 ? "KSplitButton" : _b, id = _a.id, color = _a.color, sx = _a.sx, backgroundColor = _a.backgroundColor, textColor = _a.textColor, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c;
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var anchorRef = useRef(null);
    var _e = useState(value || splitValues[0]), selectedValue = _e[0], setSelectedValue = _e[1];
    useEffect(function () {
        setSelectedValue(value);
    }, [value]);
    var handleMenuItemClick = function (index) {
        var _a, _b;
        onSplitSelect(splitValues[index]);
        setSelectedValue(splitValues[index]);
        setOpen(false);
        // Focus the next input if there's one
        // First nextSibling is the popup, so skip this one
        var input = (_b = (_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.nextElementSibling) === null || _b === void 0 ? void 0 : _b.nextElementSibling;
        if ((input === null || input === void 0 ? void 0 : input.nodeName) === "INPUT") {
            input === null || input === void 0 ? void 0 : input.focus();
        }
    };
    var handleClose = function (event) {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    var toggleOpen = function () {
        setOpen(function (prevOpen) {
            if (!prevOpen) {
                // Have to trick this because before we need to open the popup
                // Wait a tick
                setTimeout(function () {
                    var focusable = document.querySelectorAll(".KSplitButton-MenuItem")[0];
                    focusable === null || focusable === void 0 ? void 0 : focusable.focus();
                });
            }
            return !prevOpen;
        });
    };
    // Notify split button openning / closing
    useEffect(function () {
        onSplitOpen && onSplitOpen(open);
    }, [onSplitOpen, open]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(StyledButtonGroup, { className: clsx("KSplitButton", className), disableRipple: true, ref: anchorRef, "aria-label": splitLabel, "data-testid": testId, id: id, sx: sx },
            React__default.createElement(Button, { size: "small", className: clsx(buttonGroupClasses.valueButton, "KSplitButton-Button"), onClick: toggleOpen, "aria-hidden": true, tabIndex: -1, "data-testid": "".concat(testId, "-TextButton") }, selectedValue.label),
            React__default.createElement(Button, { size: "small", "aria-controls": open ? "split-button-menu" : undefined, "aria-expanded": open ? "true" : undefined, "aria-label": splitLabel, "aria-haspopup": "menu", onClick: toggleOpen, "data-testid": "".concat(testId, "-IconButton"), className: "KSplitButton-Button", color: color },
                React__default.createElement(KIcon, { className: "fa-solid fa-caret-down fa-lg" }))),
        React__default.createElement(StyledPopper, { open: open, className: clsx("KSplitButton-Popper"), anchorEl: anchorRef.current, role: undefined, transition: true, disablePortal: true, "data-testid": "".concat(testId, "-Popper") }, function (_a) {
            var TransitionProps = _a.TransitionProps, placement = _a.placement;
            return (React__default.createElement(Grow, __assign({}, TransitionProps, { style: {
                    transformOrigin: placement === "bottom" ? "center top" : "center bottom"
                } }),
                React__default.createElement(Paper, null,
                    React__default.createElement(ClickAwayListener, { onClickAway: handleClose },
                        React__default.createElement(MenuList, { id: "split-button-menu", "data-testid": "".concat(testId, "-MenuList"), className: "KSplitButton-MenuList", sx: {
                                backgroundColor: backgroundColor,
                                color: textColor,
                                ".Mui-selected:hover": { backgroundColor: backgroundColor }
                            } }, splitValues.map(function (value, index) { return (React__default.createElement(MenuItem, { key: value.id, selected: value.id === selectedValue.id, onClick: function () { return handleMenuItemClick(index); }, "data-testid": "".concat(testId, "-MenuItem"), className: "KSplitButton-MenuItem" }, value.label)); }))))));
        })));
};

export { KSplitButton as default };
//# sourceMappingURL=index.js.map
